import { useMutation, useQueryClient } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';
import type { CommonCodeGroupRequest } from '../types/code';

/**
 * PATCH /api/eraf/codes/groups/{groupCode} — 코드 그룹 수정
 * 성공 시 ['common-code', 'list'] + ['common-code', 'group', groupCode] 쿼리 무효화
 */
export function useUpdateCodeGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ groupCode, body }: { groupCode: string; body: Partial<CommonCodeGroupRequest> }) =>
      codeApi.updateGroup(groupCode, body),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ['common-code', 'list'] });
      void queryClient.invalidateQueries({
        queryKey: ['common-code', 'group', variables.groupCode],
      });
    },
  });
}
